class BaseTabs
{
    /**
     * @param {Element} element
     */
    constructor(element) {
        this.container = element;

        this.toggleButtons = Array.from(this.container.querySelectorAll('[data-tabs="button"]')).filter((element) => {
            return element.closest('[data-content]') === this.container;
        });

        this.tabContents = Array.from(this.container.querySelectorAll('[data-tabs="content"]')).filter((element) => {
            return element.closest('[data-content]') === this.container;
        });

        this.initListeners();

        if (this.toggleButtons[0]) {
            this.activateTab(this.toggleButtons[0]);
        }
    }

    initListeners() {
        Array.from(this.toggleButtons).forEach((element) => element.addEventListener('click', (event) => {
            event.preventDefault();
            return this.activateTab(event.currentTarget);
        }));
    }

    /**
     * @param {Element|EventTarget} toggleButton
     * @return {Element}
     */
    activateTab(toggleButton) {
        let activeTabName = toggleButton.getAttribute('data-load'),
            activeTabContent = this.container.querySelector(`[data-tabs="content"][data-load="${activeTabName}"]`),
            activeTabButtons = this.container.querySelectorAll(`[data-tabs="button"][data-load="${activeTabName}"]`);

        Array.from(this.toggleButtons).forEach((element) => element.classList.remove('tabs-item-active'));
        Array.from(activeTabButtons).forEach((element) => element.classList.add('tabs-item-active'));

        Array.from(this.tabContents).forEach((element) => element.classList.remove('tabs-content-item-active'));
        activeTabContent.classList.add('tabs-content-item-active');

        return activeTabContent;
    }

    /**
     * @param {string} tabName
     */
    activateTabByName(tabName) {
        this.activateTab(this.container.querySelector(`[data-tabs="button"][data-load="${tabName}"]`));
    }

    /**
     * @return {Element}
     */
    get activeTabContent() {
        return this.container.querySelector(`[data-tabs="content"].tabs-content-item-active`);
    }
}

export {BaseTabs};
